import React, { FC } from 'react';

import { Route } from 'react-router-dom';
import { Redirect, RouteComponentProps, Switch } from 'react-router';

import CampaignProductsRouteSwitch from '../campaigns/CampaignProductsRouteSwitch';
import { PageNotFound } from '../PageNotFound';

const RouteSwitch: FC<RouteComponentProps> = ({ match: { path, url } }) => {
    return (
        <Switch>
            <Route path={`${path}/campaigns`} component={CampaignProductsRouteSwitch} />
            <Redirect from={`${path}`} to={`${url}/campaigns`} />
            <Route component={PageNotFound} />
        </Switch>
    );
};

export default RouteSwitch;
